import React, { createContext, useState, useEffect } from "react";
import moment from "moment";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { useLingui } from "@lingui/react/macro";

export const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const { i18n } = useLingui();
  const [locale, setLocale] = useState(i18n.locale);

  // Sincroniza las librerias de fecha con el idioma (para meses en letra localizados).
  useEffect(() => {
    moment.locale(locale);
    dayjs.locale(locale);
  }, [locale]);

  const changeLocale = (newLocale) => {
    i18n.activate(newLocale);
    setLocale(newLocale);
  };

  return (
    <LocaleContext.Provider value={{ locale, changeLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};
